import React from 'react';
import { Button, Form, Modal, Space } from 'antd';
import { IModal } from 'common/models/model.interface';
import { ReactComponent as AdmitIcon } from 'assets/icons/admit.svg';
import { ReactComponent as TurnbackIcon } from 'assets/icons/turnback.svg';
import './driving-privileges-revoked-modal.scss';
import { ILicensePlateDrivingPrivilegesRead } from 'common/services/citation-service/citation.service.types';
import { formatCustomDateTime } from 'common/helpers/date.helper';

export interface IDrivingPrivilegesRevokeModalProps {
  drivingPrivilageData: ILicensePlateDrivingPrivilegesRead;
  isVacantAddress: boolean;
}

const DrivingPrivilegesRevokeModal = ({ title, isEdit, initData, isOpen, onClose }: IModal<IDrivingPrivilegesRevokeModalProps, any>) => {
  const [form] = Form.useForm();

  const hideModal = (...rest: any) => {
    if (onClose) {
      onClose(...rest);
    }
  };

  const handleClickAdmit = () => {
    hideModal(true, 'admit');
  };

  const handleTurnbackAdmit = () => {
    hideModal(true, 'turnback');
  };

  const getTitle = () => {
    return <div className="driving-privilages-revoked-title">warning: driving privilages revoked</div>;
  };

  return (
    <Modal
      centered
      title={getTitle()}
      width={550}
      open={isOpen}
      wrapClassName="custom-modal"
      closable={true}
      onCancel={() => hideModal(false)}>
      <Space className="full-width driving-privilages-revoked-body">
        <div>
          The vehicle with license plate <span className="bold">{initData?.drivingPrivilageData?.licensePlate}</span> has had it's driving
          privileges suspended due to repeated speeding violations.
        </div>
        <div className="bold suspension-period">
          Suspension period: {initData?.drivingPrivilageData?.days} days (Ending on{' '}
          {formatCustomDateTime(initData?.drivingPrivilageData?.revokUntil)})
        </div>
        <div>Access may still be approved; however, the entry will be flagged.</div>
      </Space>
      <Space className="footer">
        <Button type="primary" className="primary-btn mobile-btn" icon={<AdmitIcon />} onClick={handleClickAdmit}>
          Approve
        </Button>
        {!initData?.isVacantAddress && (
          <Button className="important-btn mobile-btn" icon={<TurnbackIcon />} onClick={handleTurnbackAdmit}>
            Turnback
          </Button>
        )}
      </Space>
    </Modal>
  );
};

export default React.memo(DrivingPrivilegesRevokeModal, (prevProps, nextProps) => {
  return prevProps.isOpen === nextProps.isOpen;
});
